<div class="not-found-container" @fadeIn>
  <div class="glitch-container">
    <div class="glitch-text">
      <span
        *ngFor="let letter of letters; let i = index"
        class="letter"
        [style.animation-delay]="letterDelays[i]"
      >
        {{ letter }}
      </span>
    </div>
    <div class="glitch-text glitch-layer-1">
      <span
        *ngFor="let letter of letters; let i = index"
        class="letter"
        [style.animation-delay]="letterDelays[i]"
      >
        {{ letter }}
      </span>
    </div>
    <div class="glitch-text glitch-layer-2">
      <span
        *ngFor="let letter of letters; let i = index"
        class="letter"
        [style.animation-delay]="letterDelays[i]"
      >
        {{ letter }}
      </span>
    </div>
  </div>

  <div class="message">
    <h1>Page Not Found</h1>
    <p>Oops! We couldn't find what you're looking for.</p>
    <div class="attempted-path">
      <p>
        The path <span class="path">{{ attemptedPath }}</span> doesn't exist.
      </p>
    </div>
    <div class="illustration">
      <div class="astro">
        <div class="helmet"></div>
        <div class="body"></div>
        <div class="arm left"></div>
        <div class="arm right"></div>
        <div class="leg left"></div>
        <div class="leg right"></div>
      </div>
      <div class="planet"></div>
      <div class="stars">
        <div
          class="star"
          *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
        ></div>
      </div>
    </div>
    <button class="home-button" (click)="goToHome()">Take Me Home</button>
  </div>
</div>
